import React, { useState } from 'react';
import { apiService } from '../../constants/ApiService';


const WhatsAppButton = ({ phoneNumber, message, fileUrl, leadid, cust_id }) => {
  debugger;
  const [leadData, setLeadData] = useState({
    history_id: '0',
    lead_id: '',
    history_user_id: '0',
    history_user_name: '',
    history_date_time: null,
    history_remark: '',
    history_discription: '',
    cust_id: '0',
    subject: '',
  });

  const generateWhatsAppLink = async (
    phoneNumber,
    message,
    fileUrl = '',
    leadid,
    cust_id
  ) => {
    debugger;
    if (!phoneNumber || !message) {
      console.error('Phone number or message is missing.');
      return '';
    }

    try {
      // Prepare the data for the API request
      const data = {
        ...leadData,
        lead_id: leadid,
        cust_id: cust_id,
        history_remark: message,
        history_discription: phoneNumber,
      };

      const data1 = JSON.stringify(data);

      // API call to save lead history
      const response = await apiService.post(
        `api/Lead_Master_Import/AddLead_History`,
        data1
      );

      if (response.status === 200) {
        console.log('Lead history saved successfully:', response.data);
      } else {
        console.error('Failed to save lead history.');
      }

      // Encode the WhatsApp message
      const encodedMessage = encodeURIComponent(
        fileUrl ? `${message} \n\nHere's the file: ${fileUrl}` : message
      );

      // Return WhatsApp URL
      return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    } catch (error) {
      console.error('Error saving lead history:', error);
      alert('Something went wrong while saving lead history.');
      return ''; // Return empty if API call fails
    }
  };

  const handleClick = async () => {
    const url = await generateWhatsAppLink(
      phoneNumber,
      message,
      fileUrl,
      leadid,
      cust_id
    );

    if (url) {
      window.open(url, '_blank'); // Open the WhatsApp chat in a new tab
    } else {
      console.error('Failed to generate WhatsApp URL.');
    }
  };

  return <button onClick={handleClick}>Send WhatsApp Message</button>;
};

export default WhatsAppButton;
